import { render, staticRenderFns } from "./template12.vue?vue&type=template&id=2e813176&scoped=true"
import script from "./template12.vue?vue&type=script&lang=js"
export * from "./template12.vue?vue&type=script&lang=js"
import style0 from "./template12.vue?vue&type=style&index=0&id=2e813176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e813176",
  null
  
)

export default component.exports